(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('OrderPicture', OrderPicture);

    OrderPicture.$inject = ['$resource'];

    function OrderPicture ($resource) {
        var resourceUrl =  'api/customer-orders/:id/pictures';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
